import { ReactElement } from "react";
import styles from "rivals/components/shared/Icons/Icons.module.scss";
import { ICON_SIZE_10, ICON_SIZE_24 } from "./constants";
import type { IconProps } from "./iconPropsTypes";

const RankHot = ({
  fill = styles.pass,
  height = ICON_SIZE_24,
  width = ICON_SIZE_10
}: IconProps): ReactElement => (
  <svg
    fill="none"
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M6.17043 16.5748H0L10 9V21L6.17043 16.5748Z"
        fill={fill}
        id="arrow-1"
        opacity="0.5"
      />
      <path
        d="M7.17043 12.5748H1L11 5V17L7.17043 12.5748Z"
        fill={fill}
        id="arrow-2"
        opacity="0.7"
      />
      <path
        d="M8.17043 8.57484H2L12 1V13L8.17043 8.57484Z"
        fill={fill}
        id="arrow-3"
      />
    </g>
    <title>rank hot movement</title>
  </svg>
);

export default RankHot;
